import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface PrVnta {
  active: number;
  characs?: Features[];
  classnId: any;
  code: string;
  createdAt: any;
  description: string;
  generalActivities: any[];
  name: string;
  productSatKey: string;
  sections: any[];
  unitSatKey: string;
  updatedAt: any;
}

interface Features {
  id?: string;
  name: string;
  nameUnit?: string;
  unitId: any;
  value: string;
}

export interface PrVntaId extends PrVnta {
  id: string;
}

@Injectable()
export class ProductVntaService {

  prVntaCollection: AngularFirestoreCollection<PrVnta>;
  prVntas: any;

  prVntaDocument: AngularFirestoreDocument<PrVntaId>;
  prVnta: Observable<PrVntaId>;

  collection: string;
  classnRef: string;
  activityCollection: string;
  unitRef: string;

  // NOTE: Change this any for PrVnta Interface
  prVnta$: Observable<any>;
  prVntas$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router,
  ) {
    this.activityCollection = Globals.ACTIVITY_COLLECTION;
    this.collection = Globals.PRVNTA_COLLECTION;
    this.classnRef = Globals.PRTYPE_COLLECTION;
    this.unitRef = Globals.UNIT_COLLECTION;
  }

  /**
   * Get all prVntas with references
   * @return {Observable} Arrays of prVntas
   */
  getPrVntas({onEmpty=undefined}={}) {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true)).map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(document => {
        const classRef = document.classnId.path;
        return this.afh.docWithIds$(classRef).map(data => {
          return { data: data, ...document };
        })
      });
    })
    .mergeMap(prVntasDocuments => Observable.combineLatest(prVntasDocuments));
  }

  /**
  * Get prVnta data
  * @param {string} sid - The id of the prVnta
  * @return {Observable} The PrVnta Object
  */
  getPrVnta(sid: string, collection = this.collection) {
    return this.prVnta$ = this.afh.docWithIds$(collection + '/' + sid).map(document => {
      const classRef = this.afh.docWithIds$(document.classnId.path);
      return Observable.combineLatest(
        classRef,
        (classData) => {
          return {
            classns: classData
          };
      })
      .map(data => {
        return {
          data: data.classns,
          ...document
        };
      });
    })
    .mergeMap(prVntasDocuments => Observable.combineLatest(prVntasDocuments));
  }


  /**
  * Create new prVnta
  * @param {PrVnta} prVnta - The data of the prVnta
  */
  addPrVnta(prVnta: PrVnta) {
    prVnta.classnId = this.afh.doc(`${this.classnRef}/${prVnta.classnId}`).ref;
    prVnta.characs.map(charac => {
      charac.unitId = this.afh.doc(`${this.unitRef}/${charac.unitId}`).ref
    });
    this.afh.add(`${this.collection}`, prVnta);
    this.router.navigate(['/prVnta']);
  }

  /**
   * Update current prVnta
   * @param {string} sid - The id of the prVnta
   * @param {PrVnta} prVnta - The data of the prVnta
   */
  updatePrVnta(sid: string, prVnta: any) {
    prVnta.classnId = this.afh.doc(`${this.classnRef}/${prVnta.classnId}`).ref;
    prVnta.characs.map(charac => {
      charac.unitId = this.afh.doc(`${this.unitRef}/${charac.unitId}`).ref
    });
    this.afh.update(`${this.collection}/${sid}`, prVnta);
    this.router.navigate(['/prVnta']);
  }

  /**
   * Delete current prVnta
   * @param {string} sid - The id of the prVnta
   */
  deletePrVnta(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  getUnitDoc(ref: string) {
    return this.afh.docWithIds$(ref);
  }
}

export class PrVntaData {
  productSatKeyObjects = {
    '01010101': { description: 'No existe en el catálogo' },
    '24121500': { description: 'Cajas, bolsas y sacos para empaquetado' },
    '25101503': { description: 'Carros' },
    '32131021': { description: 'Sustrato cerámico combustión combinada a baja temperatura' },
    '32131022': { description: 'Cerámica para sustratos de tableros de circuitos impresos pcb' },
    '32131023': { description: 'Soporte de dispositivos eléctricos o electrónicos' },
    '32141000': { description: 'Tubos electrónicos' },
    '55101500': { description: 'Publicaciones impresas' },
    '73181005': { description: 'Servicios de troquelado' },
    '73151904': { description: 'Servicios de impresión industrial offset' },
    '84111506': { description: 'Servicios de facturación' },
    '25101801': { description: 'Motocicleta' },
  }
  unitSatKeyObjects = {
    'H87': { description: 'Pieza' },
    'H88': { description: 'MegaOhm kilómetro' },
    'H89': { description: 'Por ciento por Ohmio' },
    'E48': { description: 'Unidad de Servicio' },
    'ACT': { description: 'Actividad' },
  }
}

/* class PRVNTA{
  active;
  characs;
  classnId;
  code;
  createdAt;
  description;
  generalActivities;
  name;
  productSatKey;
  sections;
  unitSatKey;
  updatedAt;

  constructor(name, description, className, productSatKey, unitSatKey, sectionName){
    let cLass = JSON.parse(localStorage.prTypes)[className];
    this.active = true;
    this.characs = [];
    this.classnId = cLass.id;
    this.code = `${cLass.code}${Math.ceil(Math.random()*1000)}${Math.ceil(Math.random()*100)}${Math.ceil(Math.random()*1000)}`;
    this.createdAt = new Date();
    this.description = description;
    this.generalActivities = JSON.parse(localStorage.genActJson);
    this.name = name;
    this.productSatKey = productSatKey;
    this.sections = [{
      activities: JSON.parse(localStorage.nonGenActJson),
      backInk: 1,
      frontInk: 1,
      height: 1,
      name: sectionName,
      pieceInSize: 1,
      sheetHeight: 1,
      sheetWidth: 1,
      sizeInPaper: 1,
      width: 1
    }];
    this.unitSatKey = unitSatKey;
    this.updatedAt = this.createdAt;
  }
} */